import { Controller } from "stimulus";

export default class ShowController extends Controller {
  static targets = ["videoContainer"];

  loadEpisode(event) {
    const timestamp = parseInt(event.currentTarget.dataset.timestamp);
    if (isNaN(timestamp)) return;

    const videoElement = this.element.querySelector('[data-controller~="media--video-player"]');
    const videoPlayer = videoElement &&
      this.application.getControllerForElementAndIdentifier(videoElement, 'media--video-player');
    if (videoPlayer) {
      event.preventDefault();
      videoPlayer.seekTo(timestamp);
      return;
    }

    // Without a player to drive, let the link reload the page at ?timestamp=
    if (!this.audioUrlValue) return;

    event.preventDefault();

    const audioPlayer = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-audio-player]'),
      'media--audio-player'
    );

    audioPlayer.loadEpisode({
      itemId: this.itemIdValue,
      itemType: this.itemTypeValue,
      audioUrl: this.audioUrlValue,
      timestamp: timestamp
    });
  }

  openComments(event) {
    let maxTop = 300;

    if (this.hasVideoContainerTarget) {
      const videoContainer = this.videoContainerTarget;
      const videoContainerRect = videoContainer.getBoundingClientRect();
      maxTop = videoContainerRect.bottom + window.scrollY;
    }

    event.preventDefault();
    this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-comments-drawer] [data-controller="drawer"]'),
      'drawer'
    ).open({height: window.innerHeight - maxTop});
  }
}

ShowController.values = { itemId: Number, itemType: String, audioUrl: String };